var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._b({class:['far', 'fa-lg', _vm.value ? 'fa-check-square' : 'fa-square'],on:{"click":function($event){return _vm.$emit('click', $event.target)}}},'i',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }